import { Link } from "react-router-dom";
import { useLang, pickTitle, pickSummary, timeAgo, SECTIONS, imgSrc } from "../lib/i18n";

function useSectionLabel(category) {
  const { lang } = useLang();
  const sec = SECTIONS.find((s) => s.id === category);
  return sec ? (lang === "hi" ? sec.hi : sec.en) : category;
}

export default function NewsCard({ article: a, variant = "standard" }) {
  const { lang } = useLang();
  const label = useSectionLabel(a.category);
  const title = pickTitle(a, lang);

  if (variant === "list") {
    return (
      <Link
        to={`/article/${a.id}`}
        data-testid={`news-card-${a.id}`}
        className="group block border-b border-subtle py-3.5"
      >
        <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-brk">{label}</span>
        <h3 className="font-hindi text-base md:text-lg leading-snug mt-1 group-hover:text-deepgreen transition-colors">
          {title}
        </h3>
        <span className="font-mono text-[11px] text-muted-foreground">{timeAgo(a.published_at, lang)}</span>
      </Link>
    );
  }

  if (variant === "small") {
    return (
      <Link
        to={`/article/${a.id}`}
        data-testid={`news-card-${a.id}`}
        className="group flex gap-4 border-b border-subtle py-3.5"
      >
        {a.image_url && (
          <div className="w-24 h-20 shrink-0 overflow-hidden border border-ink/10">
            <img
              src={imgSrc(a.image_url)}
              alt={title}
              loading="lazy"
              onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.closest("div").style.display = "none"; }}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        )}
        <div className="min-w-0">
          <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-brk">{label}</span>
          <h3 className="font-hindi text-sm md:text-base leading-snug mt-0.5 group-hover:text-deepgreen transition-colors line-clamp-2">
            {title}
          </h3>
          <span className="font-mono text-[11px] text-muted-foreground">{timeAgo(a.published_at, lang)}</span>
        </div>
      </Link>
    );
  }

  return (
    <Link to={`/article/${a.id}`} data-testid={`news-card-${a.id}`} className="group block">
      {a.image_url && (
        <div className="overflow-hidden border border-ink/15 bg-white">
          <img
            src={imgSrc(a.image_url)}
            alt={title}
            loading="lazy"
            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.closest("div").style.display = "none"; }}
            className="w-full aspect-video object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      )}
      <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-brk mt-3 block">{label}</span>
      <h3 className="font-hindi text-lg md:text-xl leading-snug mt-1 group-hover:text-deepgreen transition-colors">
        {title}
      </h3>
      <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed line-clamp-2">{pickSummary(a, lang)}</p>
    </Link>
  );
}
